import { IShadowUser } from '../interfaces/shadowUser';
import { IPairUserRoleCatalog } from '../interfaces/pairUserRoleCatalog';
import { IPairUserRoleFile } from '../interfaces/pairUserRoleFile';
import { IPairUserGroup } from '../interfaces/pairUserGroup';
import { IPairUserRole } from '../interfaces/pairUserRole';
import { fillArray } from './_models.helper';
import { PairUserRoleFile } from './pairUserRoleFile';
import { PairUserRole } from './pairUserRole';
import { PairUserGroup } from './pairUserGroup';
import { PairUserRoleCatalog } from './pairUserRoleCatalog';

export class ShadowUser implements IShadowUser {
    avatar: string;
    canExportContract: boolean;
    canDoExportSemplice: boolean;
    canDoExportGas: boolean;
    canDoExportEe: boolean;
    canMoveCustomers: boolean;
    canStopContracts: boolean;
    contractDelayTolerance: number;
    email: string;
    firstName: string;
    id: number;
    insertDate: Date;
    isDisabled: boolean;
    lastModifiedDate: Date;
    lastName: string;
    needVerificationCall: boolean;
    rUsersGroupsIdGroupNavigation: IPairUserGroup[];
    rUsersRoles: IPairUserRole[];
    rUsersRolesCatalogs: IPairUserRoleCatalog[];
    rUsersRolesFiles: IPairUserRoleFile[];
    reliabilityPercentage: number;
    teleselling: boolean;
    thumbnail: string;
    username: string;
    canDoAdesioneADistanza: boolean;
    canHandleStopForErrors: boolean;
    canDoChiamataBenvenuto: boolean;
    canDoPortaUnAmico: boolean;

    constructor(su?: IShadowUser) {
        if (su) {
            this.canExportContract = su.canExportContract;
            this.canMoveCustomers = su.canMoveCustomers;
            this.canStopContracts = su.canStopContracts;
            this.contractDelayTolerance = su.contractDelayTolerance;
            this.email = su.email;
            this.firstName = su.firstName;
            this.id = su.id;
            this.insertDate = su.insertDate;
            this.isDisabled = su.isDisabled;
            this.lastModifiedDate = su.lastModifiedDate;
            this.lastName = su.lastName;
            this.needVerificationCall = su.needVerificationCall;
            this.rUsersGroupsIdGroupNavigation = fillArray(su.rUsersGroupsIdGroupNavigation, PairUserGroup);
            this.rUsersRoles = fillArray(su.rUsersRoles, PairUserRole);
            this.rUsersRolesCatalogs = fillArray(su.rUsersRolesCatalogs, PairUserRoleCatalog);
            this.rUsersRolesFiles = fillArray(su.rUsersRolesFiles, PairUserRoleFile);
            this.reliabilityPercentage = su.reliabilityPercentage;
            this.teleselling = su.teleselling;
            this.username = su.username;
            this.canDoAdesioneADistanza = su.canDoAdesioneADistanza;
            this.canHandleStopForErrors = su.canHandleStopForErrors;
            this.canDoChiamataBenvenuto = su.canDoChiamataBenvenuto;
            this.canDoPortaUnAmico = su.canDoPortaUnAmico;
        }
    }


}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/classes/shadowUser.ts